// Sprint 57.6 — curated list of country calling codes for the phone
// dropdown. LatAm-first (where CavernicolApp tenants actually operate)
// plus a few extra common destinations. Sorted by dial code length
// descending so a longest-prefix match against a raw phone string never
// picks a shorter code that's actually a substring of a longer one.
const COUNTRY_CODES = [
  { code: '+52', country: 'México', flag: '🇲🇽' },
  { code: '+1', country: 'Estados Unidos / Canadá', flag: '🇺🇸' },
  { code: '+34', country: 'España', flag: '🇪🇸' },
  { code: '+54', country: 'Argentina', flag: '🇦🇷' },
  { code: '+55', country: 'Brasil', flag: '🇧🇷' },
  { code: '+56', country: 'Chile', flag: '🇨🇱' },
  { code: '+57', country: 'Colombia', flag: '🇨🇴' },
  { code: '+58', country: 'Venezuela', flag: '🇻🇪' },
  { code: '+51', country: 'Perú', flag: '🇵🇪' },
  { code: '+593', country: 'Ecuador', flag: '🇪🇨' },
  { code: '+591', country: 'Bolivia', flag: '🇧🇴' },
  { code: '+595', country: 'Paraguay', flag: '🇵🇾' },
  { code: '+598', country: 'Uruguay', flag: '🇺🇾' },
  { code: '+506', country: 'Costa Rica', flag: '🇨🇷' },
  { code: '+507', country: 'Panamá', flag: '🇵🇦' },
  { code: '+503', country: 'El Salvador', flag: '🇸🇻' },
  { code: '+502', country: 'Guatemala', flag: '🇬🇹' },
  { code: '+504', country: 'Honduras', flag: '🇭🇳' },
  { code: '+505', country: 'Nicaragua', flag: '🇳🇮' },
  { code: '+1809', country: 'Rep. Dominicana', flag: '🇩🇴' },
  { code: '+53', country: 'Cuba', flag: '🇨🇺' },
];

export const COUNTRY_CODES_SORTED = [...COUNTRY_CODES].sort((a, b) => b.code.length - a.code.length);

export function findCountryByCode(code) {
  return COUNTRY_CODES.find(c => c.code === code);
}

// Splits a raw phone string ("+52 55 1234 5678") into its dial code and the
// rest, using a longest-prefix match. Falls back to { code: '', rest: value }
// when nothing matches (e.g. a number with no leading '+').
export function splitPhoneValue(value) {
  if (!value) return { code: '', rest: '' };
  const trimmed = value.trim();
  for (const c of COUNTRY_CODES_SORTED) {
    if (trimmed === c.code || trimmed.startsWith(`${c.code} `) || trimmed.startsWith(c.code)) {
      const rest = trimmed.slice(c.code.length).trimStart();
      return { code: c.code, rest };
    }
  }
  return { code: '', rest: trimmed };
}

export default COUNTRY_CODES;
